package com.karyadina.service

/**
 * Stub implementation of PurchaseHandler - used when iap module not available
 * Features unlocked by default
 */
class StubPurchaseHandler : PurchaseHandler {
    override suspend fun launchPurchaseFlowFromActivity(activity: Any?, packageId: String) {
        println("StubPurchaseHandler.launchPurchaseFlowFromActivity (no-op)")
    }

    override suspend fun getAvailableProducts(): Map<String, PurchaseHandler.Product> {
        return emptyMap()
    }
}
